import {Directive, ElementRef, EventEmitter, Output} from '@angular/core';
import {ScrollbarService } from '../services/scrollbar.service';
import { WindowService} from '../services/window.service';
import {ManageVisibility} from '../models/manage-visibility.class';
export class CbjInViewDirective extends ManageVisibility {
   show = new EventEmitter<ElementRef>();
/**
 * @param {?} el
 * @param {?} scroll
 * @param {?} window
 */
constructor(public el: ElementRef,
public scroll: ScrollbarService,
public window: WindowService) {
    super(el, scroll, window);
  }
/**
 * check for visibility of element
 * @return {?}
 */
manageVisibility(): void {
    const /** @type {?} */ winHeight = this.window.height;

    const /** @type {?} */ scrollTrigger = this.offsetTop + 150 - winHeight;

    if (!this.eivVisible && this.scroll.scrollPos >= scrollTrigger) {
      this.eivVisible = true;
      this.show.emit(this.el);
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[cbjInView]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ScrollbarService, },
{type: WindowService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'show': [{ type: Output, args: ['show', ] },],
};
}

function CbjInViewDirective_tsickle_Closure_declarations() {
/** @type {?} */
CbjInViewDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjInViewDirective.ctorParameters;
/** @type {?} */
CbjInViewDirective.propDecorators;
/** @type {?} */
CbjInViewDirective.prototype.show;
/** @type {?} */
CbjInViewDirective.prototype.el;
/** @type {?} */
CbjInViewDirective.prototype.scroll;
/** @type {?} */
CbjInViewDirective.prototype.window;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
